// App.js
import './App.css'; // Ensure you have this import for the global style
import theme from './theme'; // Import your theme
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TopAppBar from './components/TopAppBar'; // Import Top App Bar
import Footer from './components/Footer'; // Import Footer
import Home from './pages/Home'; // Import Home page
import Services from './pages/Services'; // Import Services page
import Contact from './pages/Contact'; // Import Contact page
import Blog from './pages/Blog'; // Import Blog page
import AdminLogin from './pages/AdminLogin'; // Import Admin Login page
import AdminDashboard from './pages/AdminDashboard'; // Import Admin Dashboard page
import Article from './pages/Article'; // Import Article page for reading full content

// NEW IMPORT
import InteligențaArtificială from './pages/InteligențaArtificială'; // Import the new page

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <div className="App">
          {/* Top App Bar */}
          <TopAppBar />

          {/* Main content area with flex-grow to fill space */}
          <div className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/admin/login" element={<AdminLogin />} /> {/* Admin login page */}
              <Route path="/admin/dashboard" element={<AdminDashboard />} /> {/* Admin dashboard */}
              <Route path="/blog/:id" element={<Article />} /> {/* Article page for reading full content */}

              {/* NEW ROUTE FOR INTELIGENȚĂ ARTIFICIALĂ */}
              <Route
                path="/inteligenta-artificiala"
                element={<InteligențaArtificială />}
              />
            </Routes>
          </div>

          {/* Footer Section */}
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
